import { Component, EventEmitter, Output } from '@angular/core';
import { ArticleExcelImport } from 'src/app/shared/models/article-excel-import.model';
import { read, utils } from 'xlsx';
import { NgxSpinnerService } from "ngx-spinner";
import { AppToastService } from 'src/app/shared/toast-service/toast-service';
import { UploadService } from '../services/upload.service';

@Component({
  selector: 'app-excel-import',
  templateUrl: './excel-articles-import.component.html',
  styleUrls: ['./excel-articles-import.component.scss'],
  standalone: false
})
export class ExcelArticlesImportComponent {
  articlesFromExcel: ArticleExcelImport[] | any;
  displayError: boolean = false;
  errorMessage: string = "";

  @Output()
  close: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private spinner: NgxSpinnerService,
    public toastService: AppToastService,
    private uploadService: UploadService
  ) { }

  /**
   * Handles the file upload event.
   * @param $event the file upload event
   */
  handleExcelArticlesImport($event: any) {
    this.displayError = false;
    const files = $event.target.files;
    // Update the filename display span
    const display = document.getElementById('importFileNameDisplay');
    if (display) { display.textContent = files.length ? files[0].name : 'No file chosen'; }
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], { defval: null });
          // Define the expected column names
          const expectedColumns = [
            'ArticleId', 'Inside Width', 'Outside Width', 'Product Name',
            'Profile Type', 'Country', 'Application',
          ];
          // Get the actual column names from the first row of the Excel sheet
          const actualColumns = Object.keys(rows[0] as object);

          // Validate the column names
          const isValid = expectedColumns.every(column => actualColumns.includes(column));

          if (!isValid) {
            this.showError("Error uploading Excel: Column names do not match the expected format.");
            return;
          }
          this.articlesFromExcel = rows.map((row: any) => new ArticleExcelImport(file.name, row));
        }
      };
      reader.readAsArrayBuffer(file);
    }
  }

  /**
   * Uploads the Excel content to the S3 bucket.
   */
  uploadExcelArticles() {
    if (!!!this.articlesFromExcel) {
      this.showError("Please upload an Excel file first.");
    } else {
      this.spinner.show();
      console.log('articlesFromExcel', this.articlesFromExcel);
      this.uploadService.uploadImportedArticles(this.articlesFromExcel).subscribe({
        next: (response => {
          console.log('response', response);
          if (response) { // Adjust this check based on your API response structure
            this.toastService.show(`${this.articlesFromExcel.length} File(s) uploaded successfully`, { classname: 'bg-success text-light', delay: 4000 });
            this.closeModal();
          } else {
            this.showError(response?.message || "Upload unsuccessful. Please try again.");
          }
          this.spinner.hide();
        }),
        error: (error => {
          console.log('error', error);
          this.spinner.hide();
          this.showError("Upload unsuccessful. Please try again.");
        }),
        complete: () => {
          this.spinner.hide();
        }
      })
    }
  }

  /**
   * Shows an error message in the modal above the submit button.
   * @param message the error message to display
   */
  showError(message: string) {
    this.displayError = true;
    this.errorMessage = message;
  }

  closeModal() {
    this.close.emit();
  }
}
